import { render, staticRenderFns } from "./SubscriptionManager.vue?vue&type=template&id=04644484&scoped=true"
import script from "./SubscriptionManager.vue?vue&type=script&lang=js"
export * from "./SubscriptionManager.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionManager.vue?vue&type=style&index=0&id=04644484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04644484",
  null
  
)

export default component.exports